import { useState, useEffect } from 'react';
import '../styles/Footer.css';
import {
  fetchVisitorSummary,
  markVisitTrackedToday,
  shouldTrackVisitToday,
  trackVisit,
} from '../services/analytics';

function Footer() {
  const [visitorStats, setVisitorStats] = useState({
    totalVisitors: 0,
    uniqueVisitorsToday: 0,
    uniqueVisitorsThisMonth: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const trackVisitor = async () => {
      try {
        let summary;

        if (shouldTrackVisitToday()) {
          const trackResponse = await trackVisit();
          summary = trackResponse?.summary;
          markVisitTrackedToday();
        } else {
          summary = await fetchVisitorSummary();
        }

        setVisitorStats({
          totalVisitors: summary?.totalVisitors || 0,
          uniqueVisitorsToday: summary?.uniqueVisitorsToday || 0,
          uniqueVisitorsThisMonth: summary?.uniqueVisitorsThisMonth || 0,
        });
      } catch (error) {
        console.error('Error tracking visitor:', error);
        setVisitorStats({
          totalVisitors: 0,
          uniqueVisitorsToday: 0,
          uniqueVisitorsThisMonth: 0,
        });
      } finally {
        setLoading(false);
      }
    };

    trackVisitor();
  }, []);

  return (
    <footer className="institute-footer">
      <div className="footer-wrapper">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Contact Us</h3>
            <h4>IITH Knowledge Resource Centre (KRC)</h4>
            <p>Indian Institute of Technology Hyderabad</p>
            <p>Telangana - 502284 | India</p>
            <p>Tel: 040-23596750   |   Email: office.library@iith.ac.in</p>
            <p className="map-link">
              <a href="https://www.google.com/maps/place/Knowledge+Research+Centre+(Central+Library),+IITH/@17.5922332,78.1219276,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcbf198c170be3d:0x970af2e61e40f68c!8m2!3d17.5922332!4d78.1245025!16s%2Fg%2F11sf4hyt_z?entry=ttu&g_ep=EgoyMDI2MDExOS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                📍 How to reach KRC?
              </a>
            </p>
          </div>

          <div className="footer-section visitor-counter-section">
            <h3>📊  Visitors</h3>
            <div className="visitor-counter">
              {loading ? (
                <p className="counter-text">Loading...</p>
              ) : (
                <>
                  <p className="counter-number">{visitorStats.totalVisitors.toLocaleString()}</p>
                  <p className="counter-label">Total Visitors</p>
                  <p className="counter-text">Today: {visitorStats.uniqueVisitorsToday.toLocaleString()}</p>
                  <p className="counter-text">This Month: {visitorStats.uniqueVisitorsThisMonth.toLocaleString()}</p>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; 2026 Indian Institute of Technology Hyderabad, Kandi, Sangareddy, Telangana, India. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
